import React, { Component } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { Control, Errors } from 'react-redux-form';
import ReactSelect from 'react-select';
import classnames from 'classnames';

class MultiSelect extends Component {
    render() {
        let reactSelect = props => <ReactSelect {...props} />;
        let formRowClassNames = classnames({
            form__row: true,
            'form__row--error': !this.props.valid && this.props.touched,
            'form__row--disabled': this.props.disabled
        });

        return (
            <div className={formRowClassNames}>
                <div className="form__label">
                    <span className="form__title">
                        {this.props.title}
                        {this.props.isRequired ? (
                            <span className="form__required">*</span>
                        ) : (
                            ''
                        )}
                    </span>
                </div>
                <Control.custom
                    model={this.props.model}
                    id={this.props.model}
                    component={reactSelect}
                    value={this.props.value}
                    options={this.props.options}
                    onChange={this.props.onChange}
                    validators={this.props.validators}
                    name={this.props.model}
                    disabled={this.props.disabled}
                    placeholder={this.props.placeholder}
                    mapProps={{
                        onChange: props => props.onChange
                    }}
                />
                <Errors
                    wrapper={props => (
                        <div className="form__error-messages">
                            {props.children}
                        </div>
                    )}
                    className="errors"
                    model={this.props.model}
                    show="touched"
                    messages={this.props.messages}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, { model }) => {
    return {
        valid: get(state.forms, `${model}.$form.valid`, false),
        touched: get(state.forms, `${model}.$form.touched`, false)
    };
};

export default connect(mapStateToProps)(MultiSelect);



// WEBPACK FOOTER //
// ./src/components/ui/multi-select-basic.js